import React from "react"
import { Button } from "../../../../../../../../../components/parts/buttons/button"
import Color from "../../../../../../../../../style/enum/color"
import styled from "styled-components"

interface IProps {
  save: () => void
  cancel: () => void
}

export const Buttons = ({ save, cancel }: IProps) => (
  <Wrapper>
    <Cancel onClick={cancel}>キャンセル</Cancel>
    <Save onClick={save}>保存</Save>
  </Wrapper>
)

const Wrapper = styled.div`
  text-align: right;
`

const Cancel = styled(Button).attrs({
  borderColor: Color.DIMGRAY,
  color: Color.DIMGRAY,
})`
  width: 100px;
`

const Save = styled(Button).attrs({
  backgroundColor: Color.BRAND,
  color: Color.WHITE,
})`
  width: 100px;
`
